import type { StationaryCapacityRangeConfig } from './useStationaryCapacityRange';

/** Partner rolling window (14 days, start–end labels). */
export const PARTNER_ROLLING_CAPACITY_RANGE = {
  kind: 'rolling-days',
  dayCount: 14,
  labelMode: 'start-end'
} as const satisfies StationaryCapacityRangeConfig;

/** Partner Mon–Sat week — same paging as the customer flow, with no booking-horizon cap. */
export const PARTNER_WEEK_CAPACITY_RANGE = {
  kind: 'week',
  labelMode: 'start-end',
  prefetchNeighbors: true
} as const satisfies StationaryCapacityRangeConfig;

/** Customer Mon–Sat week with optional max-days-ahead + neighbor prefetch. */
export function customerWeekCapacityRange(maxDaysAhead?: number): StationaryCapacityRangeConfig {
  return {
    kind: 'week',
    maxDaysAhead,
    labelMode: 'start-only',
    prefetchNeighbors: true,
    skipInitialEmptyWeek: true
  };
}
